import React, { Component } from "react";
import style from "./ReceivePayment.module.css";
import { Button } from "reactstrap";
import moment from "moment";
//import DatePicker from "react-datepicker";
import { DatePicker } from "antd";
import api from "../../../utils/Api";
import history from "../../../utils/history";
import AdHocPaymentProof from "../AdHocPaymentProof/AdHocPaymentProof";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import {
  receiveInvoiceDetails,
  fetchpractitioner,
  fetchpatient,
  fetchSupplier,
} from "../../../redux";
import { connect } from "react-redux";
import { fetchDropdownList } from "../../../redux";
import { AutoComplete } from "antd";
import { Select } from "antd";
import {
  checkIfPermitted,
  Permissions,
} from "../../../services/RolePermissionService";
import { isValEmpty } from "../../../utils/CommonUtil";

const { Option } = Select;

export class ReceivePayment extends Component {
  constructor(props) {
    super(props);
    const name =
      localStorage.getItem("USER_INFO") &&
      JSON.parse(localStorage.getItem("USER_INFO")).name;

    this.state = {
      isPaymentProof: false,
      isInventory: false,
      isDisabled: false,

      payment_for: "1",
      name: "",
      email: "",
      payment_type: "1",
      payment_source: "1",
      account_type: "",
      payer_name: "",
      payer_account_name: "",
      payer_bank_name: "",
      payer_account_number: "",
      payee_name: "",
      payee_account_name: "",
      payee_account_number: "",
      payee_bank_name: "",
      amount: "",
      date_of_receipt: "",
      receipt_reference: "",
      capturer: name,
      inputList: [],

      successMessage: "",
      errorMessage: "",
      isLoading: false,

      emailError: "",

      receivePaymentData: [],
      supplierDropdown: [],
      supplier_id: "",
      supplier_name: "",
      showSupplier: false,

      max_upload_proof:
        localStorage.getItem("SETTING_INFO") &&
        JSON.parse(localStorage.getItem("SETTING_INFO"))
          .max_paymentproof_upload,

      patient_id: "",
      patient_name: "",
      practitioner_id: "",
      practitioner_name: "",
      showErrors: {},
      paymentrecieved_id: "",
      isScreenLoaded: false,
      isValid: false,
      isUploadError: false,
      isAmountNumberAllowed: "",
    };
  }

  async componentDidMount() {
    document.title = 'Receive Payment - TechToMedix';
    //console.log("+++++Sunil+++++++", this.props.location.state);
    //await this.fetchSupplierDropdown();
    await this.props.fetchSupplier(this.state.supplier_name);
    if (
      this.props.location.state &&
      this.props.location.state.requsted_professional &&
      this.props.location.state.requsted_professional.related_party_id &&
      this.props.location.state.related_party &&
      this.props.location.state.related_party.related_party_id
    ) {
      
      this.setState({
        showSupplier: false,
        patient_id: this.props.location.state.related_party.related_party_id,
        practitioner_id: this.props.location.state.requsted_professional
          .related_party_id,
        isDisabled:true,
      });

      this.props.receiveInvoiceDetails(
        this.props.location.state.requsted_professional.related_party_id,
        this.props.location.state.related_party.related_party_id
      );
    }else if (
      this.props.location.state &&
      this.props.location.state.patient_id &&
      this.props.location.state.practitioner_id
    ) {
      this.setState({
        showSupplier: false,
        patient_id: this.props.location.state.patient_id,
        practitioner_id: this.props.location.state.practitioner_id,
        amount: this.props.location.state.amount,
        isAppointmentPay: true,
      });

      this.props.receiveInvoiceDetails(
        this.props.location.state.practitioner_id,
        this.props.location.state.patient_id
      );
    } else {
      this.setState({
        name: "",
        showSupplier: true,
      });
    }

    // calling patient autocomplete data
    await this.props.fetchpatient(this.state.patient_name);

    // Calling practitioner autocomplete data
    await this.props.fetchpractitioner(this.state.practitioner_name);

    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
    }, 500);
  }

  onChangePatient = (value) => {
   // console.log(`selected ${value}`);
    this.setState({
      patient_name: value,
      patient_id: value,
    });
  };

  onChangePratitioner = (value) => {
   // console.log(`selected ${value}`);
    this.setState({
      practitioner_name: value,
      practitioner_id: value,
    });
  };

  onSearchPatient = (val) => {
   // console.log("Patient search:", val);
    this.setState({
      patient_name: val,
    });
    // calling patient autocomplete data
    this.props.fetchpatient(val);
  };

  onSearchPratitioner = (val) => {
    // Calling practitioner autocomplete data
    this.props.fetchpractitioner(val);
    this.setState({
      practitioner_name: val,
    });
  };

  handleOnChangePatient = async (value, event) => {
   // console.log("Value is - ", event.children);
    await this.props.fetchpatient(event.children);
    const emailVal =
      this.props.patientData &&
      this.props.patientData.patient &&
      this.props.patientData.patient.find((element, index) => {
        return element.patient_id === this.state.patient_id;
      });
    this.setState({
      email: emailVal && emailVal.email ? emailVal.email : "",
    });
  };

  onChangeSupplier = (value) => {
   // console.log(`selected ${value}`);
    this.setState({
      supplier_id: value,
    });
  };
  handleOnChangeSupplier = async (value, event) => {
    const emailVal =
      this.props.supplierData &&
      this.props.supplierData.supplier &&
      this.props.supplierData.supplier.find((element, index) => {
        return element.supplier_id === value;
      });
    this.setState({
      supplier_name: emailVal && emailVal.supplier_name ? emailVal.supplier_name : "",
      // email: emailVal.email
    });
  };

  fetchSupplierDropdown = async () => {
    const token =
      localStorage.getItem("USER_INFO") &&
      JSON.parse(localStorage.getItem("USER_INFO")).token;

    const headers = {
      Authorization: "Bearer " + token,
    };
    try {
      const response = await api.get("relatedparty/supplier/dropdown", {
        headers: headers,
      });
    //  console.log("+++++++++++++++++ supplier dropdown data", response.data);
      this.setState({ supplierDropdown: response.data.data });
    } catch (error) {}
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    return nextProps;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.receivePaymentData != this.props.receivePaymentData) {
      this.setState({
        name:
          this.props.receivePaymentData.receivePaymentDetails.payerDetails &&
          this.props.receivePaymentData.receivePaymentDetails.payerDetails
            .payer_name,
        email:
          this.props.receivePaymentData.receivePaymentDetails.payerDetails &&
          this.props.receivePaymentData.receivePaymentDetails.payerDetails
            .email,
        // patient_name:
        //   this.props.receivePaymentData.receivePaymentDetails.payerDetails &&
        //   this.props.receivePaymentData.receivePaymentDetails.payerDetails
        //     .payer_name,
        payer_name:
          this.props.receivePaymentData.receivePaymentDetails.payerDetails &&
          this.props.receivePaymentData.receivePaymentDetails.payerDetails
            .payer_name,
        payer_account_name:
          this.props.receivePaymentData.receivePaymentDetails.payerDetails &&
          this.props.receivePaymentData.receivePaymentDetails.payerDetails
            .payer_account_name,
        payer_account_number:
          this.props.receivePaymentData.receivePaymentDetails.payerDetails &&
          this.props.receivePaymentData.receivePaymentDetails.payerDetails
            .payer_account_number,
        // practitioner_name:
        //   this.props.receivePaymentData.receivePaymentDetails.payeeDetails &&
        //   this.props.receivePaymentData.receivePaymentDetails.payeeDetails
        //     .payee_name,
        payee_name:
          this.props.receivePaymentData.receivePaymentDetails.payeeDetails &&
          this.props.receivePaymentData.receivePaymentDetails.payeeDetails
            .payee_name,
        payee_account_name:
          this.props.receivePaymentData.receivePaymentDetails.payeeDetails &&
          this.props.receivePaymentData.receivePaymentDetails.payeeDetails
            .payee_account_name,
        payee_account_number:
          this.props.receivePaymentData.receivePaymentDetails.payeeDetails &&
          this.props.receivePaymentData.receivePaymentDetails.payeeDetails
            .payee_account_number,
      });
    }
  }

  getPaymentProof = (data) => {
   // console.log("Payment Proof : ", data);
  };
  // handleBlur
  // handleBlurChange = () => {
  //   if (
  //     this.state.payment_for !== "" ||
  //     this.state.email !== "" ||
  //     this.state.payment_type !== "" ||
  //     this.state.account_type !== "" ||
  //     this.state.amount !== "" ||
  //     this.state.date_of_receipt !== "" ||
  //     this.state.date_of_receipt !== null ||
  //     this.state.receipt_reference !== "" ||
  //     this.state.capturer !== ""
  //   ) {
  //     this.setState({
  //       error: "",
  //       isValid: true,
  //     });
  //   }
  // };
  // common form input handling
  handleInputChange = (event) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });
    if (name === "payment_type") {
      if (val == "2") {
        this.setState({
          isPaymentProof: true,
        });
      } else {
        this.setState({
          isPaymentProof: false,
        });
      }
    }
    if (name === "payment_for") {
      if (val == "2") {
        this.setState({
          isInventory: true,
        });
      } else {
        this.setState({
          isInventory: false,
        });
      }
    }
    if (name === "email") {
      this.validateEmail(val);
    }
    if (name === "amount") {
      this.validateNumbersOnlyAmount(event.target.value);
    }

    if (name === "payer_name" || name === "payee_name" || 
    name === "payer_bank_name"||name === "payee_bank_name") {
      const regex = /^[a-zA-Z ]*$/;
      if (!regex.test(val)) {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "Only alphabets are allowed";
        this.setState({
          showErrors:showErrors
        })
      } else {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "";
        delete showErrors[name];
        this.setState({
          showErrors:showErrors
        })
      }
    }


    if (name === "payer_account_number" || 
    name === "payee_account_number" 
  ) {
      const regex = /^[0-9]*$/;
      if (!regex.test(val)) {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "Only numbers are allowed";
        this.setState({
          showErrors:showErrors
        })
      } else {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "";
        delete showErrors[name];
        this.setState({
          showErrors:showErrors
        })
      }
    }

  };

  // Validations for only numbers allowed
  validateNumbersOnlyAmount = (value) => {
    const regex = /^[0-9]\d{0,9}(\.\d{1,2})?%?$/;

    if (!regex.test(value)) {
      this.setState({
        isAmountNumberAllowed: "Enter only numbers valid upto two decimals.",
      });
    } else {
      this.setState({
        isAmountNumberAllowed: "",
      });
    }
  };

  handleChangeDate = (date) => {
   // console.log("format date is - ", moment(date).format("YYYY-MM-DD"));
    let format_date = moment(date).format("YYYY-MM-DD");
    this.setState({
      date_of_receipt: format_date,
    });
  };

  getPaymentProof = (data) => {
  //  console.log("Payment Proof : ", data);
    this.setState({
      inputList: data,
    });
  };

  // Getting image error data from adhoc payment proof
  getImageError = (data) => {
    console.log("Is Image Error : ", data);
    this.setState({
      isUploadError: data,
    });
  };

  //email validation
  validateEmail = (email) => {
    const pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const result = pattern.test(email);
    if (result === true) {
      this.setState({
        emailError: false,
      });
    } else {
      this.setState({
        emailError: true,
      });
    }
  };

  onSubmit = async () => {
    this.validateNumbersOnlyAmount(this.state.amount);
    let isValid = this.checkIsValid();
    if (isValid === true) {
      this.onReceivePayment();
    }
  };


  checkIsValid = () => {
    if (
      isValEmpty(this.state.payment_for) ||
     // isValEmpty(this.state.email) ||
      isValEmpty(this.state.payment_type) ||
      (Number(this.state.payment_type) !== 1 && isValEmpty(this.state.account_type)) ||
      isValEmpty(this.state.amount) ||
      isValEmpty(this.state.date_of_receipt) ||
      isValEmpty(this.state.date_of_receipt) ||
      isValEmpty(this.state.receipt_reference) ||
      isValEmpty(this.state.capturer)
    ) {
      this.setState({
        error: "Please filled out all mandatory fields",
        isValid: false,
      });
      return false;
    } else {
      if (this.state.payment_for == "1") {
        if (isValEmpty(this.state.patient_id ) || isValEmpty(this.state.practitioner_id) || isValEmpty(this.state.payment_source)) {
          this.setState({
            isValid: false,
            error: "Please filled out all mandatory fields",
          });
          return false;
        } else {
          this.setState({
            error: "",
            isValid: true,
          });
        }
      } else {
        if (this.state.payment_for == "2" && this.state.payment_type == "2") {
          if (
            isValEmpty(this.state.payer_name) ||
            isValEmpty(this.state.payer_bank_name) ||
            isValEmpty(this.state.payer_account_number) ||
            isValEmpty(this.state.payee_name) ||
            isValEmpty(this.state.payee_bank_name)||
            isValEmpty(this.state.payee_account_number)
          ) {
            this.setState({
              isValid: false,
              error: "Please filled out all mandatory fields",
            });
            return false;
          } else {
            this.setState({
              error: "",
              isValid: true,
            });
          }
        } else {
          this.setState({
            error: "",
            isValid: true,
          });
        }
      }
    }

    if (isValEmpty(this.state.isAmountNumberAllowed)) {
      this.setState({
        error:"",
        isValid: true,
      });
    } else {
      this.setState({
        error: "Please filled out valid details.",
        isValid: false,
      });
      return false;
    }
    return true;
    // this.onReceivePayment();
  };

  onReceivePayment = async () => {
    if(Object.keys(this.state.showErrors).length > 0){
      this.setState({
        error: "Please filled out valid details.",
      });
      return false
    }
    this.setState({
      isLoading: true,
    });
    const formData = new FormData();
    // formData.append("name", this.state.name);
    if (
      this.props.location.state &&
      this.props.location.state.invoice_id !== null
    ) {
      formData.append("invoice_id", this.props.location.state.invoice_id);
    }

    formData.append("paymentForType", this.state.payment_for);
    if(this.state.account_type){
      formData.append("lk_account_type_id", this.state.account_type);
    }
    formData.append("payment_mode", this.state.payment_type);

    formData.append("payer_email", this.state.email);
    formData.append("payment_amount", this.state.amount);
    formData.append(
      "date_of_receipt",
      moment(this.state.date_of_receipt).format("YYYY-MM-DD")
    );
    formData.append("reciept_reference", this.state.receipt_reference);
    formData.append("capturer", this.state.capturer);

    this.state.inputList.forEach((element, index) => {
      formData.append("attachment", element.selectedFile);
      formData.append("description", element.description);
    });

    if (this.state.isInventory === false) {
      formData.append("patient_id", this.state.patient_id);
      formData.append("practitioner_id", this.state.practitioner_id);
      formData.append("payment_source", this.state.payment_source);
    } else {
      if (this.state.isPaymentProof) {
        formData.append("payer_name", this.state.payer_name);
        formData.append("payee_name", this.state.payee_name);
        formData.append("payer_bank_name", this.state.payer_bank_name);
        formData.append(
          "payer_account_number",
          this.state.payer_account_number
        );
        formData.append("payee_bank_name", this.state.payee_bank_name);
        formData.append(
          "payee_account_number",
          this.state.payee_account_number
        );
      }
    }

    // if (this.state.payment_type === "scheduled") {
    //   formData.append("name", this.state.sch_name);
    //   formData.append("frequency_recurrence", this.state.frequency_recurrence);
    //   formData.append(
    //     "termination_date",
    //     moment(this.state.sch_termination_date).format("YYYY-MM-DD")
    //   );
    // }

    if (!isValEmpty(this.state.supplier_id)) {
      formData.append("supplier_id", this.state.supplier_id);
    }

    // *****todo from payment_type dropdown set from backend data and its value will be set in payment_mode_id ****
    formData.append("payment_mode_id", 1);

    // Headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    try {
      const response = await api.post("payment/recievepayment/save", formData, {
        headers: headers,
      });

      if (response.status === 200) {
        this.setState({
          isLoading: false,
          paymentrecieved_id: response.data.data.payment.paymentrecieved_id,
          successMessage: "Payment added successfully! Please wait while redirecting...",
        });
      }
      setTimeout(() => {
        this.setState({
          successMessage: "",
        });

      if(
        this.props.location.state &&
        !isValEmpty(this.props.location.state.mediswitchTransactionId)){

          this.props.history.push({
            pathname: "/app/claimdetails/"+ this.props.location.state.mediswitchTransactionId,
          });
      }else if (
          this.props.location.state &&
          checkIfPermitted(Permissions.VIEW_INVOICE) &&
          this.props.location.state.invoice_id !== null
        ) {
          this.props.history.push({
            pathname: "/app/invoicedetails/"+this.props.location.state.invoice_id,
          });
        } else {
          if (checkIfPermitted(Permissions.VIEW_PAYMENT_TRANSACTION)) {
            this.props.history.push({
              pathname: "/app/paymenthistory",
            });
          }
        }
        if (
          this.props.location.state &&
          checkIfPermitted(Permissions.CAPTURE_INVOICE) &&
          Number(this.props.location.state.paymentType) === 1
        ) {
          this.props.history.push({
            pathname: "/app/createinvoice",
            state: {
              // isManageAppointment: true,
              // appoinment_id: this.props.match.params.id,
              // conductappointment_id: this.state.conductappointment_id,
              // related_party: relatedPartyDetails,
              // requsted_professional: reqProfessionalDetails,
              // address: this.state.PhysicalAddress,
              // invoice_id: null,
              // paymentType: this.state.paymentType,
              isManageAppointment: true,
              appoinment_id:
                this.props.location.state &&
                this.props.location.state.appoinment_id,
              conductappointment_id:
                this.props.location.state &&
                this.props.location.state.conductappointment_id,
              related_party:
                this.props.location.state &&
                this.props.location.state.related_party,
              requsted_professional:
                this.props.location.state &&
                this.props.location.state.requsted_professional,
              address:
                this.props.location.state &&
                this.props.location.state.appoinment_id,
              invoice_id: null,
              paymentType:
                this.props.location.state &&
                this.props.location.state.paymentType,
              paymentrecieved_id: this.state.paymentrecieved_id,
              appointment_reason:
                this.props.location.state &&
                this.props.location.state.appointment_reason,
              is_appointment_conducted:
                this.props.location.state &&
                this.props.location.state.is_appointment_conducted,
            },
          });
        } else {
          // this.props.history.push({
          //   pathname: "/app/paymenthistory",
          // });
        }
      }, 2000);
    } catch (error) {
      if (error.response) {
        this.setState({
          isLoading: false,
          errorMessage: "Internal server error occured",
        });
      }
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 2000);
      console.log("Add payment error", error);
    }
  };

  // previewInvoice = () => {
  //   this.props.history.push("/app/invoicedetails");
  // };

  render() {
    // console.log(
    //   "Dropdown list data: ",
    //   this.props.dropdownListData.dropdownList &&
    //     this.props.dropdownListData.dropdownList
    // );

    const receivePaymentData = this.props.receivePaymentData
      .receivePaymentDetails;

    // Getting payment mode from dropdown list
    const paymentMode =
      this.props.dropdownListData.dropdownList &&
      this.props.dropdownListData.dropdownList.payment_mode;

    // Getting account type from dropdown list
    const accountType =
      this.props.dropdownListData.dropdownList &&
      this.props.dropdownListData.dropdownList.lk_account_type;

    const paymentModeOptions =
      paymentMode &&
      paymentMode.map((element, index) => (
        <option key={index} value={element.payment_mode_id}>
          {element.payment_mode}
        </option>
      ));
    const supplierOptions =
      this.props.supplierData && this.props.supplierData.supplier;

    const accountTypeOptions =
      accountType &&
      accountType.map((element, index) => (
        <option key={index} value={element.lk_account_type_id}>
          {element.account_type}
        </option>
      ));

    const patientOptions =
      this.props.patientData && this.props.patientData.patient;

    const practitionerOptions =
      this.props.practitionerData && this.props.practitionerData.practitioner;

    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }

    return (
      <div className={style.receivePaymentMainWrapper}>
        <div className="row">
          <div className="col-md-12">
            <h3>Receive Payment</h3>
          </div>
          <div className="col-lg-12 intro-text">
            <p className="mb-4">
            Payments received by the practice from Patients or any party owing the practice funds, 
            must be captured using this form. The Receive Payment feature is used to capture inward bound payments. 
            These payments may only be once-off.
            </p>
          </div>
        </div>

        <form className={style.createRPaymentrapper}>
          <div className="form-box-shadow mb-4">
            <div className="row">
              <div className="col-lg-12">
                <h4>Payment Details</h4>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                <div className="form-group">
                  <div>
                    <label htmlFor="payment_for">
                      Payment For:{" "}
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <select
                      className="form-control"
                      id="payment_for"
                      name="payment_for"
                      onChange={this.handleInputChange}
                      disabled={this.state.isAppointmentPay}
                      value={this.state.payment_for}
                    >
                      <option value="">Select payment for</option>
                      <option value="1">Appointment</option>
                      <option value="2" disabled={this.state.isDisabled}>
                        Inventory
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            {this.state.isInventory === false && (
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                  <div className="form-group">
                    <label>
                      Patient Name{" "}
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    {/* <p>*********** {JSON.stringify(this.state.patient_id)}</p> */}
                    <Select
                      showSearch
                      allowClear={true}
                      name="patient_name"
                      placeholder="Search Patient"
                      optionFilterProp="children"
                      onChange={this.onChangePatient}
                      onSearch={this.onSearchPatient}
                      onSelect={(value, event) =>
                        this.handleOnChangePatient(value, event)
                      }
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      value={this.state.patient_id || undefined}
                      disabled={this.state.isDisabled || this.state.isAppointmentPay}
                    >
                      {patientOptions &&
                        patientOptions.map((element, index) => (
                          <Option key={index} value={element.patient_id}>
                            {element.patient_name}
                          </Option>
                        ))}
                    </Select>
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                  <div className="form-group">
                    <label>
                      Practitioner Name{" "}
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <Select
                      showSearch
                      allowClear={true}
                      name="practitioner_name"
                      placeholder="Search Practitioner"
                      optionFilterProp="children"
                      onChange={this.onChangePratitioner}
                      onSearch={this.onSearchPratitioner}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      value={this.state.practitioner_id || undefined}
                      disabled={this.state.isDisabled || this.state.isAppointmentPay}
                    >
                      {practitionerOptions &&
                        practitionerOptions.map((element, index) => (
                          <Option key={index} value={element.practitioner_id}>
                            {element.practitioner_name}
                          </Option>
                        ))}
                    </Select>
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              {/* <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                <div className="form-group">
                  <label htmlFor="name">
                    Name:{" "}
                    <span className="mandatory">
                      <small>*</small>
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    placeholder="Name"
                    onChange={this.handleInputChange}
                    value={this.state.name}
                    // value={
                    //   receivePaymentData.payerDetails &&
                    //   receivePaymentData.payerDetails.payer_name
                    // }
                  />
                </div>
              </div> */}
              <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                <div className="form-group">
                  <label htmlFor="payment_type">
                    Email:{" "}
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      this.state.emailError ? "is-invalid" : ""
                    }`}
                    name="email"
                    id="email"
                    placeholder="email"
                    onChange={this.handleInputChange}
                    // value={
                    //   receivePaymentData.payerDetails &&
                    //   receivePaymentData.payerDetails.email
                    // }
                   // disabled={this.state.isAppointmentPay}
                    value={this.state.email}
                  />
                  {this.state.emailError ? (
                    <span className="error">
                      Please Enter valid email address
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                <div className="form-group">
                  <label htmlFor="payment_type">
                    Type of Payment:{" "}
                    <span className="mandatory">
                      <small>*</small>
                    </span>
                  </label>
                  <select
                    className="form-control"
                    name="payment_type"
                    id="payment_type"
                    value={this.state.payment_type}
                   // disabled={this.state.isAppointmentPay}
                    onChange={this.handleInputChange}
                  >
                    <option value="">Select type of payment</option>
                    {paymentModeOptions}
                  </select>
                </div>
              </div>
              {Number(this.state.payment_for) === 1 && (
              <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                <div className="form-group">
                  <label htmlFor="payment_source">
                    Payment Source:{" "}
                    <span className="mandatory">
                      <small>*</small>
                    </span>
                  </label>
                  <select
                    className="form-control"
                    name="payment_source"
                    id="payment_source"
                    value={this.state.payment_source}
                   // disabled={this.state.isAppointmentPay}
                    onChange={this.handleInputChange}
                  >
                    <option value="">Select payment source</option>
                    <option value="1">Patient</option>
                    <option value="2">Medical Aid</option>
                    <option value="3">Write Off</option>
                  </select>
                </div>
              </div>)}
              {Number(this.state.payment_type) !== 1 && (
              <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                <div className="form-group">
                  <label htmlFor="account_type">
                    Account type:{" "}
                    <span className="mandatory">
                      <small>*</small>
                    </span>
                  </label>
                  <select
                    className="form-control"
                    name="account_type"
                    id="account_type"
                    value={this.state.account_type}
                    onChange={this.handleInputChange}
                  >
                    <option value="">Select account type</option>
                    {accountTypeOptions}
                  </select>
                </div>
              </div>)}
              {this.state.showSupplier && this.state.isInventory && (
                <div className="col-sm-6 col-md-6 col-lg-3 mb-3">
                  <div className="form-group">
                    <label htmlFor="supplier_id">Supplier </label>
                    {/* <select
                      className="form-control"
                      name="supplier_id"
                      id="supplier_id"
                      onChange={this.handleInputChange}
                    >
                      <option value="">Select Supplier</option>
                      {this.state.supplierDropdown &&
                        this.state.supplierDropdown.map((element, index) => (
                          <option key={index} value={element.supplier_id}>
                            {element.supplier_name}
                          </option>
                        ))}
                    </select> */}
                    <Select
                      showSearch
                      allowClear={true}
                      name="supplier_name"
                      placeholder="Search supplier"
                      optionFilterProp="children"
                      onChange={this.onChangeSupplier}
                      onSearch={this.onSearchSupplier}
                      onBlur={this.handleBlurChange}
                      onSelect={(value, event) =>
                        this.handleOnChangeSupplier(value, event)
                      }
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      value={this.state.supplier_id || undefined}
                    >
                      {supplierOptions &&
                        supplierOptions.map((element, index) => (
                          <Option key={index} value={element.supplier_id}>
                            {element.supplier_name}
                          </Option>
                        ))}
                    </Select>
                  </div>
                </div>
              )}
              {/* {!this.state.isInventory && (
                <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                  <div className="form-group">
                    <label htmlFor="amount">
                      Amount (ZAR){" "}
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <input
                      type="text"
                      id="amount"
                      name="amount"
                      placeholder="Amount (ZAR)"
                      maxLength="10"
                      onChange={this.handleInputChange}
                      className={`form-control ${
                        this.state.isAmountNumberAllowed ? "is-invalid" : ""
                      }`}
                    />
                    {this.state.isAmountNumberAllowed && (
                      <span className="error">
                        {this.state.isAmountNumberAllowed}
                      </span>
                    )}
                  </div>
                </div>
              )} */}
            {/* </div> */}

            {this.state.isPaymentProof && this.state.isInventory && (
              <React.Fragment>
                {/* <div className="row"> */}
                  <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                    <div className="form-group">
                      <label htmlFor="payer_name">
                        Pay From - Name:{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <input
                        type="text"
                        id="payer_name"
                        name="payer_name"
                        maxLength="20"
                        placeholder="Payer Name"
                        onChange={this.handleInputChange}
                        value={this.state.payer_name}
                        className={`form-control ${this.state.showErrors &&
                          this.state.showErrors.payer_name ? "is-invalid"
                            : ""
                        }`}
                      />
                      {this.state.showErrors.payer_name && (
                        <p>
                          <span className="error">
                            {this.state.showErrors.payer_name}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                    <div className="form-group">
                      <label htmlFor="payer_bank_name">
                        Pay From - Bank Name:{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <input
                        type="text"
                        id="payer_bank_name"
                        name="payer_bank_name"
                        maxLength="25"
                        placeholder="Payee Bank Name"
                        onChange={this.handleInputChange}
                        className={`form-control ${this.state.showErrors &&
                          this.state.showErrors.payer_bank_name ? "is-invalid"
                            : ""
                        }`}
                      />
                      {this.state.showErrors.payer_bank_name && (
                        <p>
                          <span className="error">
                            {this.state.showErrors.payer_bank_name}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                    <div className="form-group">
                      <label htmlFor="payer_account_number">
                        Pay From - Account Number:{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <input
                        type="text"
                        id="payer_account_number"
                        name="payer_account_number"
                        maxLength="25"
                        placeholder="Payee Account Number"
                        onChange={this.handleInputChange}
                        // value={
                        //   receivePaymentData.payerDetails &&
                        //   receivePaymentData.payerDetails.payer_account_number
                        // }
                        value={this.state.payer_account_number}
                        className={`form-control ${this.state.showErrors &&
                          this.state.showErrors.payer_account_number ? "is-invalid"
                            : ""
                        }`}
                      />
                      {this.state.showErrors.payer_account_number && (
                        <p>
                          <span className="error">
                            {this.state.showErrors.payer_account_number}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                {/* </div> */}

                {/*  <div className="row"> */}
                  <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                    <div className="form-group">
                      <label htmlFor="payee_name">
                        Pay To - Name:{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <input
                        type="text"
                        id="payee_name"
                        name="payee_name"
                        maxLength="20"
                        placeholder="Payee Name"
                        onChange={this.handleInputChange}
                        value={this.state.payee_name}
                        className={`form-control ${this.state.showErrors &&
                          this.state.showErrors.payee_name ? "is-invalid"
                            : ""
                        }`}
                      />
                      {this.state.showErrors.payee_name && (
                        <p>
                          <span className="error">
                            {this.state.showErrors.payee_name}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                    <div className="form-group">
                      <label htmlFor="payee_bank_name">
                        Pay To - Bank Name:{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <input
                        type="text"
                        id="payee_bank_name"
                        name="payee_bank_name"
                        maxLength="25"
                        placeholder="Payee Bank Name"
                        onChange={this.handleInputChange}
                        // value={
                        //   receivePaymentData.payeeDetails &&
                        //   receivePaymentData.payeeDetails.payee_account_name
                        // }
                        // value={this.state.payee_account_name}
                        className={`form-control ${this.state.showErrors &&
                          this.state.showErrors.payee_bank_name ? "is-invalid"
                            : ""
                        }`}
                      />
                      {this.state.showErrors.payee_bank_name && (
                        <p>
                          <span className="error">
                            {this.state.showErrors.payee_bank_name}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                    <div className="form-group">
                      <label htmlFor="payee_account_number">
                        Pay To - Account Number:{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <input
                        type="text"
                        id="payee_account_number"
                        name="payee_account_number"
                        maxLength="25"
                        placeholder="Payee Account Number"
                        onChange={this.handleInputChange}
                        // value={
                        //   receivePaymentData.payeeDetails &&
                        //   receivePaymentData.payeeDetails.payee_account_number
                        // }
                        value={this.state.payee_account_number}
                        className={`form-control ${this.state.showErrors &&
                          this.state.showErrors.payee_account_number ? "is-invalid"
                            : ""
                        }`}
                      />
                      {this.state.showErrors.payee_account_number && (
                        <p>
                          <span className="error">
                            {this.state.showErrors.payee_account_number}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                {/* </div> */}
              </React.Fragment>
            )}
            {/* <div className="row"> */}
              {/* {this.state.showSupplier && this.state.isInventory && ( */}
                <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                  <div className="form-group amount-input-col">
                    <label htmlFor="amount">
                      Amount (ZAR){" "}
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <input
                      type="text"
                      id="amount"
                      name="amount"
                      placeholder="Amount (ZAR)"
                      value={this.state.amount}
                      maxLength="10"
                      //disabled={this.state.isAppointmentPay}
                      onChange={this.handleInputChange}
                      className={`form-control ${
                        this.state.isAmountNumberAllowed ? "is-invalid" : ""
                      }`}
                    />
                    {this.state.isAmountNumberAllowed && (
                      <span className="error">
                        {this.state.isAmountNumberAllowed}
                      </span>
                    )}
                  </div>
                </div>
              {/* )} */}
              <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                <div className="form-group">
                  <label htmlFor="date_of_receipt">
                    Date of Receipt{" "}
                    <span className="mandatory">
                      <small>*</small>
                    </span>
                  </label>
                  <DatePicker
                    selected={
                      this.state.date_of_receipt
                        ? new Date(this.state.date_of_receipt)
                        : null
                    }
                    onChange={this.handleChangeDate}
                    className="form-control"
                    id="date_of_receipt"
                    name="date_of_receipt"
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Date of Receipt"
                  />
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                <div className="form-group">
                  <label htmlFor="receipt_reference">
                    Receipt Reference{" "}
                    <span className="mandatory">
                      <small>*</small>
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="receipt_reference"
                    name="receipt_reference"
                    maxLength="20"
                    placeholder="Receipt Reference"
                    value={this.state.receipt_reference}
                    onChange={this.handleInputChange}
                  />
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                <div className="form-group">
                  <label htmlFor="capturer">
                    Capturer{" "}
                    <span className="mandatory">
                      <small>*</small>
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="capturer"
                    name="capturer"
                    maxLength="20"
                    placeholder="Capturer"
                    value={this.state.capturer}
                    onChange={this.handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>

          {this.state.isPaymentProof && this.state.max_upload_proof && (
            <div className="form-box-shadow mb-4">
              <div className="row">
                <div className="col-lg-12">
                  <div className="mb-3">
                    <h4 className={style.proofHeading}>
                      Upload Proof of Payment
                    </h4>
                    <small>
                      {`You can upload maximum  ${this.state.max_upload_proof} proof of payment and allowed extensions are .pdf, .jpg, .png, .svg.`}
                    </small>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12">
                  <AdHocPaymentProof
                    getPaymentProof={this.getPaymentProof}
                    getImageError={this.getImageError}
                  />
                </div>
              </div>
            </div>
          )}

          {/*  Show validation message */}
          {this.state.error && (
            <div className="row">
              <div className="col-lg-12">
                <p className={` ${style.errorMessage} ${style.errorText}`}>{this.state.error}</p>
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-md-12">
              {this.state.isLoading ? (
                <div className={style.loadingWrapper}>
                  <img src={ttmLoader} alt="loader" className={style.loading} />
                </div>
              ) : (
                <div>
                  {this.state.successMessage && (
                    <p className={style.successMessage}>
                      {this.state.successMessage}
                    </p>
                  )}
                  {this.state.errorMessage && (
                    <p className={style.errorMessage}>
                      {this.state.errorMessage}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div
              className={`col-lg-12 d-flex justify-content-center justify-content-sm-end ${style.receivePaymentBtnWrapper}`}
            >
              <div>
                {this.props.location.state && (
                  <Button
                    type="button"
                    className="form-primary-btn mr-4"
                    onClick={this.onSubmit}
                  >
                    Receive Payment
                  </Button>
                )}
                {!this.props.location.state && (
                  <Button
                    type="button"
                    className="form-primary-btn"
                    onClick={this.onSubmit}
                  >
                    ADD Payment
                  </Button>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

// export default ReceivePayment;
const mapStateToProps = (state) => {
  return {
    receivePaymentData: state.receivePaymentDetails,
    dropdownListData: state.dropdownList,
    practitionerData: state.practitioner,
    patientData: state.patient,
    supplierData: state.supplier,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    receiveInvoiceDetails: (payeeId, payerId) =>
      dispatch(receiveInvoiceDetails(payeeId, payerId)),
    fetchDropdownList: () => dispatch(fetchDropdownList()),
    fetchpractitioner: (practitionerName) =>
      dispatch(fetchpractitioner(practitionerName)),
    fetchpatient: (patientName) => dispatch(fetchpatient(patientName)),
    fetchSupplier: (supplier_name) => dispatch(fetchSupplier(supplier_name)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReceivePayment);
